module.exports = __webpack_public_path__ + "static/img/QRcode.78ed7074.png";